import DocumentUploader from './uploader';

type TUploadDocumentProps = {
  file: File | string | undefined;
  setFile: React.Dispatch<React.SetStateAction<File | undefined>>;
  title: string;
  description: string;
};

const UploadDocument = ({
  file,
  setFile,
  title,
  description,
}: TUploadDocumentProps) => {
  return (
    <>
      <div>
        <span>
          {title}
          <span className="color-red-3">*</span>
        </span>
        <div className="pt-1 pb-2">
          <small className="color-gray-1">{description}</small>
        </div>
      </div>
      <DocumentUploader file={file} setFile={setFile} />
    </>
  );
};

export default UploadDocument;
